export const blogs = [
  {
    title: "The Rise of Quick Commerce: How It's Changing Local Shopping",
    date: '2024-06-01',
    summary: 'Quick commerce is revolutionizing how we shop for daily needs. Learn how local vendors and customers both benefit from this new trend.',
    link: '/blog/quick-commerce',
    image: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=800&auto=format&fit=crop&q=60'
  },
  {
    title: 'Supporting Local Vendors in the Digital Age',
    date: '2024-05-20',
    summary: 'Discover why supporting your neighborhood shops is more important than ever, and how platforms like Dailzy make it easy.',
    link: '/blog/supporting-local-vendors',
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=800&auto=format&fit=crop&q=60'
  },
  {
    title: 'Top 5 Benefits of Using Dailzy for Your Daily Essentials',
    date: '2024-05-10',
    summary: 'From transparent pricing to fast delivery, see why Dailzy is the best choice for your daily shopping.',
    link: '/blog/dailzy-benefits',
    image: 'https://images.unsplash.com/photo-1607083206968-13611e3d76db?w=800&auto=format&fit=crop&q=60'
  }
]; 